export default __webpack_public_path__ + "static/media/question.b9c5d800.svg";